import React, { useState, useEffect } from 'react';
import './Navbar.css';
import NavbarButtonGroup from './NavbarButtonGroup.tsx';
import { PiSidebarSimple, PiSidebarSimpleFill } from 'react-icons/pi';

interface NavbarProps {
  onCollapse: (isCollapsed: boolean) => void;
}

const Navbar: React.FC<NavbarProps> = ({ onCollapse }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    onCollapse(!isCollapsed);
  };

  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add('navbar-collapsed');
    } else {
      document.body.classList.remove('navbar-collapsed');
    }
  }, [isCollapsed]);

  return (
    <div className={`navbar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="navbar-header">
        {isCollapsed ?
          <div className="navbar-header-button" onClick={handleCollapse}>
            <PiSidebarSimpleFill />
          </div>
          :
          <h1>Shoebox</h1>
        }
        {!isCollapsed ?
          <div className="navbar-header-button" onClick={handleCollapse}>
            <PiSidebarSimple />
          </div>
          :
          null
        }
      </div>
      <NavbarButtonGroup isCollapsed={isCollapsed} />
    </div>
  );
};

export default Navbar;